import { Text } from '@thanx/uikit/text'
import useCurrentMerchantUser from 'hooks/useCurrentMerchantUser'
import { buildTranslate } from 'locales'
import React, { useEffect, useRef } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Loading from './Loading'

const t = buildTranslate('components.zendesk')

const ZENDESK_BASE_URL = 'https://thanx.zendesk.com'
const HELP_CENTER_HOST = 'help.thanx.com'

// Zendesk enforces its own return_to rules, but only forward values we can
// see are Help Center pages, in case that enforcement ever changes.
function safeReturnTo(search: string) {
  const returnTo = new URLSearchParams(search).get('return_to')
  // Browsers treat backslashes in URLs like forward slashes, so /\host
  // resolves to another origin; reject them outright.
  if (!returnTo || returnTo.includes('\\')) return null
  if (returnTo.startsWith('/') && !returnTo.startsWith('//')) return returnTo

  try {
    const url = new URL(returnTo)
    if (url.protocol === 'https:' && url.host === HELP_CENTER_HOST) {
      return returnTo
    }
  } catch {
    // fall through: not a parseable absolute URL
  }
  return null
}

const ZendeskSSO = ({ location }: RouteComponentProps) => {
  const merchantUser = useCurrentMerchantUser()
  const returnTo = safeReturnTo(location.search)
  // The merchant user may still be loading when this page first renders;
  // wait for it, but only ever hand off to Zendesk once.
  const hasRedirected = useRef(false)

  useEffect(() => {
    const jwt = merchantUser?.zendesk_sso_jwt
    if (!jwt || hasRedirected.current) return

    hasRedirected.current = true
    const params = new URLSearchParams({ jwt })
    if (returnTo) params.set('return_to', returnTo)
    window.location.replace(`${ZENDESK_BASE_URL}/access/jwt?${params}`)
  }, [merchantUser, returnTo])

  if (merchantUser && !merchantUser.zendesk_sso_jwt) {
    return (
      <Text.BodyText3 className="p-xl text-center" tag="div" color="grey70">
        {t('sso_unavailable')}
      </Text.BodyText3>
    )
  }

  return <Loading />
}

export default ZendeskSSO
